/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotKindOfDelivery {
    DELIVERY_SERVICE_CONTRACTOR = "DELIVERY_SERVICE_CONTRACTOR",
    POST = "POST",
    UPS_PARCEL_SERVICE = "UPS_PARCEL_SERVICE",
    VELO_EXPRESS = "VELO_EXPRESS",
    BY_CUSTOMER = "BY_CUSTOMER"
}
